<template>
  <v-dialog
    v-model="dialog"
    max-width="380"
    persistent
    content-class="confirm-dialog"
  >
    <div class="confirm-card">
      <h3 class="confirm-card__title">Session Expired</h3>
      <p class="confirm-card__message">
        Your session has expired. Please log in again to continue.
      </p>

      <div class="confirm-card__actions">
        <button
          class="confirm-card__btn confirm-card__btn--confirm"
          @click="relogin"
        >
          Re-login
        </button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "TheSessionExpiredDialog",
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    sessionExpired() {
      return this.$store.state.sessionExpired.visible;
    },
  },
  watch: {
    sessionExpired(val) {
      this.dialog = val;
    },
  },
  methods: {
    relogin() {
      this.dialog = false;
      this.$store.commit("updateSessionExpired", false);
      if (this.$route.name !== "PageConsoleLogout") {
        // PageConsoleLogout clears the auth store and redirects to login.
        this.$router.push({ name: "PageConsoleLogout" });
      }
    },
  },
};
</script>
